var TEAMS = 'TEAMS';
var TEAM_MEMBERS = 'TEAM_MEMBERS';
var team = 'team';
var statsVisibility = 'statsVisibility';
var SELECTED_TEAMS = 'SELECTED_TEAMS';
var FILTERS = 'FILTERS';
var SELECTED_VIEW = 'SELECTED_VIEW';
export { TEAMS, TEAM_MEMBERS, team, statsVisibility, SELECTED_TEAMS, FILTERS, SELECTED_VIEW };